export const MS_TEAMS_WELCOME_FORM_NAME = 'organizationsMSTeamsWelcomeEdit'
